import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EndUserType } from "../types/EndUserType";
import { apiClient } from "src/utils/Api/apiClient";
import { stat } from "fs/promises";


interface endUserState {
        endUsers: Array<EndUserType>;
        endUsersLoading: boolean;
        endUsersError: string | null;
}

const initialState: endUserState = {
        endUsers: [],
        endUsersLoading: true,
        endUsersError: null
}

export const getEndUsersByDealerID = createAsyncThunk(
        'endUser/getEndUsersByDealerID',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUser/getEndUsersByDealerID/${endUserData}`);
                        return response.data;
                } catch (error: any) {
                        return rejectWithValue(error.response.data || 'An error occured');
                }
        }
);

export const deleteEndUser = createAsyncThunk(
        'endUser/deleteEndUser',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUser/deleteEndUser', endUserData).then();
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);

export const getEndUsers = createAsyncThunk(
        'endUser/getEndUsers',
        async (endUserData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUser/getEndUsers/${endUserData}`);
                        return response.data;
                } catch (error: any) {
                        return rejectWithValue(error.response.data || 'An error occured');
                }
        }
);

const endUsersSlice = createSlice({
        name: 'endUsers',
        initialState,
        reducers: {
                endUsersReset: () => initialState,
                insertEndUser: (state, action) => {
                        const id = action.payload.Id;
                        const index = state.endUsers.findIndex(item => item.Id === id);
                        if (index !== -1) {
                                state.endUsers[index] = action.payload;
                        }
                        else {
                                state.endUsers.push(action.payload);
                        }
                },
        },
        extraReducers: (builder) => {
                //get all endUsers from server
                builder.addCase(getEndUsers.pending, (state) => {
                        state.endUsersLoading = true;
                        state.endUsersError = null;
                });
                builder.addCase(getEndUsers.fulfilled, (state, action) => {
                        state.endUsersLoading = false;
                        state.endUsers = action.payload;
                });
                builder.addCase(getEndUsers.rejected, (state, action) => {
                        state.endUsersLoading = false;
                        state.endUsersError = action.payload as string;
                });

                //delete endUser from server
                builder.addCase(deleteEndUser.pending, (state) => {
                        state.endUsersLoading = true;
                        state.endUsersError = null;
                });
                builder.addCase(deleteEndUser.fulfilled, (state, action) => {
                        state.endUsersLoading = false;
                        const id = action.payload.Id;
                        state.endUsers = state.endUsers.filter(item => item.Id !== parseInt(id));
                });
                builder.addCase(deleteEndUser.rejected, (state, action) => {
                        state.endUsersLoading = false;
                        state.endUsersError = action.payload as string;
                });

                //get all endUsers from server by dealer id
                builder.addCase(getEndUsersByDealerID.pending, (state) => {
                        state.endUsersLoading = true;
                        state.endUsersError = null;
                });
                builder.addCase(getEndUsersByDealerID.fulfilled, (state, action) => {
                        state.endUsersLoading = false;
                        state.endUsers = action.payload;
                });
                builder.addCase(getEndUsersByDealerID.rejected, (state, action) => {
                        state.endUsersLoading = false;
                        state.endUsersError = action.payload as string;
                });

        }
});

export const { endUsersReset, insertEndUser } = endUsersSlice.actions;
export default endUsersSlice.reducer;
